module.exports = __webpack_public_path__ + "img/lg_ring_r_s_null_0@3x.a33bc18b.png";